const transition = (OgComponent) => {
  return () => (
    <>
      <OgComponent />
    </>
  );
};

export default transition;
